import { render, staticRenderFns } from "./RelatedProductCourse.vue?vue&type=template&id=fb22ec3c"
import script from "./RelatedProductCourse.vue?vue&type=script&lang=js"
export * from "./RelatedProductCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports